module.exports = __webpack_public_path__ + "static/img/169_TO8_1916.2a0af39.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/169_TO8_1916.jpg
// module id = PEfC
// module chunks = 0